var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sup',[_vm._v("\n    Archived\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }